import formatPrice from '../../../helper/formatPrice'

const priceGetterValue = (props) => {
  const { value } = props
  return formatPrice(value)
}

export default priceGetterValue
